export default __webpack_public_path__ + "static/media/eh.77f36af4.svg";